export const selectPageType = (state) => state.page?.type;
